import { Injectable, ErrorHandler, Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { AiMonitoringService } from './monitoring.service';

@Injectable({
  providedIn: 'root',
})
export class GlobalErrorHandlerService implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error: Error | HttpErrorResponse) {
    const monitoringService = this.injector.get(AiMonitoringService);

    if (error instanceof HttpErrorResponse) {
      // Server error

      if (error.url && (error.url.indexOf('/photo/$value') > -1 || error.url.indexOf('/getPhoto') > -1)) {
        //dont care about this exception
      } else {
        monitoringService.xwareLogErrorStack(error.message || error.toString());
      }
    } else {
      // Client Error
      monitoringService.xwareLogErrorStack(error.stack);
    }
  }
}
